import { createSlice } from '@reduxjs/toolkit';

import axios from 'utils/axiosClient';
import { dispatch } from '../index';

const initialState = {
    dot: null,
    danhMuc: { traiKy: [], tangBacTuChau: [], giaoPham: [] },
    phieu: null,
    canEdit: false,
    loaded: false,
    saving: false,
    error: null,
    dialogOpen: false
};

const slice = createSlice({
    name: 'capNhatThongTin',
    initialState,
    reducers: {
        // Đổi tài khoản trong cùng tab: store là module-level và không persist, nên state của
        // người trước còn nguyên trong RAM sau khi đăng xuất. Đặt lại TOÀN BỘ về mặc định.
        datLai() {
            return { ...initialState };
        },
        // Chỉ dùng cho LỖI TẢI (lỗi gửi đi có `saveFailure` riêng, và `saveFailure` cố ý
        // KHÔNG xoá `dot` để phiếu đang mở không biến mất giữa chừng).
        hasError(state, action) {
            state.error = action.payload;
            state.loaded = true;
            // Xoá dữ liệu của lần tải trước: nếu hạnh sinh khác vừa đăng nhập mà request
            // hỏng, không được để họ nhìn thấy phiếu của người trước.
            state.dot = null;
            state.phieu = null;
            state.danhMuc = { traiKy: [], tangBacTuChau: [], giaoPham: [] };
            state.canEdit = false;
        },
        getHienTaiSuccess(state, action) {
            state.dot = action.payload?.dot ?? null;
            state.danhMuc = action.payload?.danhMuc ?? { traiKy: [], tangBacTuChau: [], giaoPham: [] };
            state.phieu = action.payload?.phieu ?? null;
            state.canEdit = action.payload?.canEdit === true;
            state.loaded = true;
            state.error = null;
        },
        saveStart(state) {
            state.saving = true;
            state.error = null;
        },
        saveSuccess(state, action) {
            state.phieu = action.payload;
            state.saving = false;
            state.dialogOpen = false;
        },
        saveFailure(state, action) {
            state.saving = false;
            state.error = action.payload;
        },
        moDialog(state) {
            state.dialogOpen = true;
        },
        dongDialog(state) {
            state.dialogOpen = false;
        }
    }
});

export default slice.reducer;

export const { datLai, moDialog, dongDialog } = slice.actions;

// Kê khai là việc phụ: mọi lỗi ở đây chỉ ghi vào state, không được nổi lên màn hình
// và không được làm hỏng trang chủ.
export function getCapNhatThongTinHienTai() {
    return async () => {
        try {
            const response = await axios.get('/capnhatthongtin/current');
            dispatch(slice.actions.getHienTaiSuccess(response));
        } catch (error) {
            dispatch(slice.actions.hasError(error?.message || 'Không tải được thông tin cập nhật.'));
        }
    };
}

export function saveCapNhatThongTin(input) {
    return async () => {
        dispatch(slice.actions.saveStart());

        try {
            const response = await axios.post('/capnhatthongtin', { ...input });
            dispatch(slice.actions.saveSuccess(response));
            return { ok: true };
        } catch (error) {
            const hetHan = error?.response?.status === 400;
            const message = error?.response?.data?.message || 'Không gửi được, vui lòng thử lại.';
            dispatch(slice.actions.saveFailure(message));
            return { ok: false, message, hetHan };
        }
    };
}
